import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

async function invioDocumenti(uuid, apiPath) {
  return new Promise(async (resolve, reject) => {
    API.getAxios(apiPath).get(`/invioDocumenti/${uuid}/id-card`)
      .then((result) => {
        resolve(result);
      })
      .catch(errore => { 
        reject();
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  })
}

export function invioDocumentiPriority2(uuid,apiPath){
  return (dispatch) => {
    API.getAxios(apiPath).get(`/invioDocumenti/${uuid}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(sendReviewingLoanEmail(uuid, apiPath));
        }
        dispatch({ type: actionTypes.STEP_AVANTI_FINE});
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
      })
      .catch(errore => { 
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  };
}

export function sendRemainderEmail(uuid,apiPath){
  return (dispatch) => {
    API.getAxios(apiPath).post(`/pratica/${uuid}/email-reminder`)
      .then(response => {
        dispatch({ type: actionTypes.STEP_AVANTI_FINE});
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
      })
      .catch(errore => { 
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  }
}

export function sendReviewingLoanEmail(uuid, apiPath){
  return (dispatch, getState) => {
    API.getAxios(apiPath).post(`/reviewingLoan/${uuid}`)
      .then(response => {
        console.log('Email di presa in carico inviata con successo');
        const sendDocumentsLater = getState().dataReducer.modello.datiPratica.sendDocumentsLater;
        if (response.status === 200 && sendDocumentsLater === true) {
          dispatch(notifyUploadDocs(uuid, apiPath));
        }
      })
      .catch(errore => { 
        console.error('Errore invio email presa in carico:', errore);
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  }
}

export function notifyUploadDocs(uuid, apiPath){
  return (dispatch) => {
    API.getAxios(apiPath).post(`/notifyUploadDocs/${uuid}`)
      .then(response => {
        console.log('Notifica upload documenti inviata con successo');
      })
      .catch(errore => { 
        console.error('Errore notifica upload documenti:', errore);
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  }
}

export default invioDocumenti;